import { useCallback, useState } from 'react';

function useService<
  FC extends (...args: any[]) => Promise<Awaited<ReturnType<FC>>>
>(func: FC, deps: any[]) {
  const [loading, setLoading] = useState(false);

  const useService = useCallback(async (...args: Parameters<FC>) => {
    setLoading(true);
    try {
      return await func(...args);
    } finally {
      setLoading(false);
    }
  }, deps);

  return { service: useService, loading };
}

export default useService;
